import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/dzxxwk-logo.png'


const _hoisted_1 = { class: "lk-portal-dzxxwk-login" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass({'lk-portal-dzxxwk-login-content': true})
}
const _hoisted_3 = { class: "lk-portal-dzxxwk-login-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "lk-portal-dzxxwk-login-content-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "专病数据管理平台")
], -1)
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass({'lk-portal-dzxxwk-login-content-login-modal': true})
}
const _hoisted_6 = { class: "embed-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"19px"} }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "lk-portal-dzxxwk-login-container" }, [
  /*#__PURE__*/_createElementVNode("footer", { class: "lk-portal-dzxxwk-login-footer" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("零氪科技提供技术支持©2019 "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank"
      }, "京ICP备15001843号-1")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginBox = _resolveComponent("LoginBox")!
  const _component_PrivateLogin = _resolveComponent("PrivateLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass({ 'embed-passport-login': true, 'private-passport-login': _ctx.state.isInHospEnv && _ctx.isNuc }),
              id: "embed-passport-login"
            }, [
              (_ctx.state.isInHospEnv && _ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_LoginBox, {
                    key: 0,
                    loginBoxOutStyle: false,
                    showForget: ""
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.isInHospEnv && !_ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_PrivateLogin, { key: 1 }))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ], 512), [
          [_vShow, _ctx.state.logo]
        ])
      ])
    ]),
    _hoisted_8
  ]))
}